<template>
  <div class="layout-footer">
    by
    <span class="font-medium ml-2">DoctorApp</span>
  </div>
</template>
<style lang="scss" scoped></style>
